export default __webpack_public_path__ + "static/media/download.ac265a5a.png";